<template>
  <div class="Composite-container">
    <el-container style="height: 100%;">
      <!--1、左侧边栏-->
      <el-aside style="" class="el-asideClass" :width="sideWidth+'px'">
        <Left :fff_left_collapseFlag="collapseFlag"
              :fff_left_logoTextShowFlag="logoTextShowFlag">
        </Left>
      </el-aside>
      <!--2、右边主体-->
      <!--2.1、右边头部个人姓名-->
      <el-container>
        <el-header>
          <Top :fff_top_fold-data="foldData"
               :fff_top_foldClick="foldClick"
               :fff_top_user="user"> <!--向person传递user-->
          </Top>
        </el-header>
        <!--2.2、右边主体-->
        <el-main>
          <!--当前页面子路由展示区域，用于展示User...-->
          <router-view @person_fff_user="person_fff_user"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Left from "@/vue_views/components/Left.vue";
import Top from "@/vue_views/components/Top.vue";

export default {
  name: "Composite",
  components: {
    Left,
    Top
  },
  data() {
    return {
      foldData: 'foldClass el-icon-s-fold',// 折叠类
      collapseFlag: false, // 是否折叠
      sideWidth: 200, // 左侧边栏宽度
      logoTextShowFlag: true,
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
    }
  },
  methods: {
    /*子传父*/
    person_fff_user(val) { //这里val就是person传过来的user
      this.$http.post("user/select", val).then(res => {
        this.user = res.data.object
        // 更新本地user
        this.user.token = JSON.parse(localStorage.getItem("user")).token // 保留原有token
        localStorage.setItem("user", JSON.stringify(this.user))
      })
    },
    /*折叠点击*/
    foldClick() {
      this.collapseFlag = !this.collapseFlag
      if (this.collapseFlag) {
        this.sideWidth = 64 // 与导航栏一致
        this.foldData = 'foldClass el-icon-s-unfold'
        this.logoTextShowFlag = false
      } else {
        this.sideWidth = 200
        this.foldData = 'foldClass el-icon-s-fold'
        this.logoTextShowFlag = true
      }
    }
  }
}
</script>

<style>/*这个位置不能加scoped*/

/*主容器*/
.Composite-container {
  height: 100%;
}

/*侧边栏样式*/
.el-asideClass {
  background-color: rgb(238, 241, 246);
  height: 100%;
  /*box-shadow: 2px 0 6px rgb(0, 21, 41, 0.35);*/
}

/*菜单样式*/
.el-menuClass {
  height: 100%;
  overflow: hidden;
}

/*右侧头部*/
.el-headerClass {
  font-size: 12px;
  border-bottom: 1px solid #cccccc;
  line-height: 60px;
  display: flex;
}
</style>
